import React, { useState } from 'react';
import { Card, Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login } = useAuth();
  const { getThemeColors } = useTheme();
  const colors = getThemeColors();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await login(email, password);
    
    if (!result.success) {
      setError(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div 
      className="login-container"
      style={{
        minHeight: '100vh',
        background: `linear-gradient(135deg, ${colors.primary}20, ${colors.secondary}20)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Container>
        <Row className="justify-content-center">
          <Col md={6} lg={4}>
            <Card 
              className="shadow-lg border-0"
              style={{
                background: colors.surface,
                borderRadius: '15px',
                overflow: 'hidden'
              }}
            >
              <Card.Header 
                className="text-center py-4"
                style={{
                  background: `linear-gradient(135deg, ${colors.primary}, ${colors.secondary})`,
                  color: 'white',
                  border: 'none'
                }}
              >
                <div className="mb-3">
                  <i className="fas fa-calculator" style={{ fontSize: '3rem' }}></i>
                </div>
                <h3 className="mb-0">123 Accounting</h3>
                <p className="mb-0 opacity-75">BAS Management System</p>
              </Card.Header>
              
              <Card.Body className="p-4">
                <Form onSubmit={handleSubmit}>
                  {error && (
                    <Alert variant="danger" className="mb-3">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      {error}
                    </Alert>
                  )}
                  
                  <Form.Group className="mb-3">
                    <Form.Label>
                      <i className="fas fa-envelope me-2"></i>
                      Email Address
                    </Form.Label>
                    <Form.Control
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Enter your email"
                      required
                      style={{
                        borderColor: colors.border,
                        background: colors.background
                      }}
                    />
                  </Form.Group>
                  
                  <Form.Group className="mb-4">
                    <Form.Label>
                      <i className="fas fa-lock me-2"></i>
                      Password
                    </Form.Label>
                    <Form.Control
                      type="password"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      placeholder="Enter your password"
                      required
                      style={{
                        borderColor: colors.border,
                        background: colors.background
                      }}
                    />
                  </Form.Group>
                  
                  <Button
                    type="submit"
                    disabled={loading}
                    className="w-100 py-2"
                    style={{
                      background: `linear-gradient(135deg, ${colors.primary}, ${colors.secondary})`,
                      border: 'none',
                      borderRadius: '8px',
                      fontSize: '1.1rem',
                      fontWeight: '600'
                    }}
                  >
                    {loading ? (
                      <>
                        <i className="fas fa-spinner fa-spin me-2"></i>
                        Signing In...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-sign-in-alt me-2"></i>
                        Sign In
                      </>
                    )}
                  </Button>
                </Form>
              </Card.Body>
              
              <Card.Footer 
                className="text-center py-3"
                style={{
                  background: colors.background,
                  border: 'none',
                  color: colors.textSecondary
                }}
              >
                <small>
                  <i className="fas fa-shield-alt me-1"></i>
                  Secure authentication powered by 123Group
                </small>
              </Card.Footer>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
